import cx from 'classnames'

import { getStoreTags } from 'components/ShopTile/utils'
import { useThemeContext } from 'theme/themeProvider'

import OfferTagRibon from '../OfferTagRibon'

import classes from './styles.module.scss'

type Props = {
  tags?: string[]
}

export default function OfferTagsHeader({ tags }: Props) {
  const { isDarkMode } = useThemeContext()
  const filteredTags = getStoreTags(tags)

  if (filteredTags.length > 0) {
    return (
      <>
        <header className={cx(classes.root, !isDarkMode && classes.lightMode)}>
          <h4 className={classes.text} data-testid='shop-tile-tag'>
            {filteredTags[0].toUpperCase()}
          </h4>
        </header>
        {filteredTags?.[1] && <OfferTagRibon tag={filteredTags?.[1].toUpperCase()} isDarkMode={isDarkMode} />}
      </>
    )
  }

  return null
}
